import React from "react";
import Icon from "../../../components/AppIcon";

interface LeaseStatsCardProps {
	title: string;
	value: string | number;
	subtitle: string;
	icon: string;
	color: "primary" | "success" | "warning" | "error";
	trend?: {
		direction: "up" | "down";
		value: string;
	};
}

const LeaseStatsCard: React.FC<LeaseStatsCardProps> = ({
	title,
	value,
	subtitle,
	icon,
	color,
	trend,
}) => {
	const getColorClasses = (color: "primary" | "success" | "warning" | "error") => {
		switch (color) {
			case "primary":
				return "bg-primary/10 text-primary border-primary/20";
			case "success":
				return "bg-success/10 text-success border-success/20";
			case "warning":
				return "bg-warning/10 text-warning border-warning/20";
			case "error":
				return "bg-error/10 text-error border-error/20";
			default:
				return "bg-muted/10 text-muted-foreground border-border";
		}
	};

	return (
		<div className="bg-card border border-border rounded-lg p-4 sm:p-5 card-shadow overflow-hidden">
			<div className="flex items-center justify-between mb-3 gap-2">
				<div className={`p-2 sm:p-2.5 rounded-lg flex-shrink-0 ${getColorClasses(color)}`}>
					<Icon name={icon as any} size={18} className="sm:w-5 sm:h-5" />
				</div>
				{trend && (
					<div
						className={`flex items-center space-x-1 text-xs sm:text-sm flex-shrink-0 ${
							trend.direction === "up" ? "text-success" : "text-error"
						}`}
					>
						<Icon
							name={trend.direction === "up" ? "TrendingUp" : "TrendingDown"}
							size={14}
							className="sm:w-4 sm:h-4"
						/>
						<span className="whitespace-nowrap">{trend.value}</span>
					</div>
				)}
			</div>

			<div className="min-w-0">
				<h3 className="text-lg sm:text-xl font-bold text-foreground mb-1 truncate">{value}</h3>
				<p className="text-xs sm:text-sm text-muted-foreground mb-1 truncate">{title}</p>
				{subtitle && (
					<p className="text-xs text-muted-foreground truncate">{subtitle}</p>
				)}
			</div>
		</div>
	);
};

export default LeaseStatsCard;
